<template>
    <div>
        <v-card flat color="lightgray">
            <v-card-text class="text-h6 font-weight-bold pb-0">
                {{userData.name}}
            </v-card-text>
        </v-card>

        <!-- salary-sheet is declared here to use it as ref -->
        <salary-sheet v-if="0" ref="SalarySheet" :salary="salary"/>

        <!-- salary-sheet is declared here to use it as ref -->
        <vication-sheet ref="VicationSheet"/>

        <!-- administrative-sheet is declared here to use it as ref -->
        <administrative-sheet ref="AdministrativeSheet"/>

        <!-- stock-details-sheet is declared here to use it as ref -->
        <stock-details-sheet ref="StockDetailsSheet"/>

        <loader v-if="loading"/>

        <v-container v-else>
			<!-- current balance -->
            <template v-if="usePrices">
				<div class="d-flex flex-column align-center">
					<div class="text-body-1 font-weight-bold mb-0">{{$T('current-balance')}}</div>
					<span
						class="text-h5 font-weight-bold primary--text profile__balance-value"
						@click="$refs.StockDetailsSheet.activeSheet"
					>
						{{$options.filters.formatNumber(balance || 0, 3)}}
					</span>
				</div>
				<v-divider class="mt-2 mb-4 mx-auto" inset/>
			</template>

            <!-- buttons -->
            <v-row justify="center" class="mb-5">
                <!-- Administrative button -->
                <v-col cols="3" class="d-inline-flex flex-column align-center" >
					<v-btn
						fab
						color="primary"
						@click="$refs.AdministrativeSheet.activeSheet"
					>
                        <v-icon size="1.9rem">mdi-clipboard-text-outline</v-icon>
                    </v-btn>
                    <span class="mt-3 text-subtitle-2">{{$T('administrative')}}</span>
                </v-col>

                <!-- Leaves button -->
                <v-col cols="4" class="d-inline-flex flex-column align-center">
					<v-btn
						fab
						color="primary"
						@click="$refs.VicationSheet.activeSheet"
					>
                        <v-icon size="1.9rem">mdi-airplane</v-icon>
                    </v-btn>
                    <span class="mt-3 text-subtitle-2">{{$T('leaves')}}</span>
                </v-col>

                <!-- Salary botton -->
                <v-col v-if="0" cols="3" class="d-inline-flex flex-column align-center">
                    <v-btn
                      fab
                      @click="$refs.SalarySheet.activeSheet"
                      color="primary"
                    >
                        <v-icon size="1.9rem">mdi-currency-usd</v-icon>
                    </v-btn>
                    <span class="mt-3 text-subtitle-2">{{$T('salary')}}</span>
                </v-col>
            </v-row>

            <!-- visits -->
            <v-card outlined class="mb-5">
                <v-card-title class="text-body-2">
                    <v-icon color="secondary" class="me-2">mdi-briefcase-check-outline</v-icon>
                    <span>{{$T('visits')}}</span>
                </v-card-title>

                <v-card-text>
                    <span class="text-subtitle-2 font-weight-bold">{{$T('today-visits')}}</span>
                    <v-progress-linear
                      color="primary"
                      class="mt-3 mb-1"
                      background-color="grey lighten-2"
                      rounded
                      height="10"
                      :value="(target.visitsToday / (target.value || 10)) * 100"
                    />
                    <span>
						{{
							$T('you-have-completed-$-out-of-$', {
								num1: target.visitsToday || 0,
								num2: $options.filters.formatNumber(target.value, 3) || 10
							})
						}}
                    </span>
                </v-card-text>
            </v-card>

            <!-- customers by type -->
            <v-card v-if="customersByType.length" outlined class="mb-5">
                <v-card-title class="text-body-2">
                    <v-icon color="secondary" class="me-2">mdi-account-group-outline</v-icon>
                    <span>{{$T('customers-by-type')}}</span>
                    <v-spacer/>
                    <v-chip small outlined color="primary">
                        {{$options.filters.formatNumber(customersTotal)}}
                    </v-chip>
                </v-card-title>

                <v-card-text>
                    <div
                        v-for="(type, index) in customersByType"
                        :key="type.id"
                        :class="{ 'mt-4': index }"
                    >
                        <div class="d-flex align-center justify-space-between">
                            <span class="text-subtitle-2 font-weight-bold">{{type.name}}</span>
                            <span class="text-subtitle-2 font-weight-bold primary--text">
                                {{$options.filters.formatNumber(type.count)}}
                            </span>
                        </div>

                        <v-progress-linear
                            color="primary"
                            class="mt-2 mb-1"
                            background-color="grey lighten-2"
                            rounded
                            height="10"
                            :value="type.percentage"
                        />

                        <span class="text-caption grey--text text--darken-1">
                            {{$T('$-of-total-customers', { num: type.percentage })}}
                        </span>
                    </div>
                </v-card-text>
            </v-card>

            <!-- work days stats -->
            <v-card outlined class="mb-5">
                <v-card-title class="text-body-2">
                    <v-icon color="secondary" class="me-2">mdi-calendar-check-outline</v-icon>
                    <span>{{$T('work-days-stats')}}</span>
                </v-card-title>

                <v-progress-linear
                    indeterminate
                    height="3"
                    color="primary"
                    :active="workDaysStatsLoading"
                />

                <v-card-text>
                    <v-row dense>
                        <!-- from date -->
                        <v-col cols="6">
                            <v-dialog v-model="fromDialog" max-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        :value="fromDate"
                                        :label="$T('from-date')"
                                        readonly
                                        dense
                                        hide-details
                                        outlined
                                        prepend-inner-icon="mdi-calendar-start"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="fromDate"
                                    :max="toDate"
                                    @input="fromDialog = false; fetchWorkDaysStats()"
                                />
                            </v-dialog>
                        </v-col>

                        <!-- to date -->
                        <v-col cols="6">
                            <v-dialog v-model="toDialog" max-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        :value="toDate"
                                        :label="$T('to-date')"
                                        readonly
                                        dense
                                        hide-details
                                        outlined
                                        prepend-inner-icon="mdi-calendar-end"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="toDate"
                                    :min="fromDate"
                                    @input="toDialog = false; fetchWorkDaysStats()"
                                />
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <v-row dense class="work-days-stats__values mt-3 text-center" :class="{ 'work-days-stats__values--loading': workDaysStatsLoading }">
                        <v-col cols="6">
                            <div class="text-h6 font-weight-bold success--text">
                                {{$options.filters.formatNumber(workDaysStats.workDays || 0)}}
                            </div>
                            <div class="text-caption grey--text text--darken-1">{{$T('visit-days')}}</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-h6 font-weight-bold error--text">
                                {{$options.filters.formatNumber(workDaysStats.absentDays || 0)}}
                            </div>
                            <div class="text-caption grey--text text--darken-1">{{$T('interruption-days')}}</div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <!-- financial target -->
            <template v-if="shouldShowFinancialTarget">
                <v-card outlined class="mb-5">
                    <v-card-title class="text-body-2">
                        <v-icon color="secondary" class="me-2">mdi-cash</v-icon>
                        <span>{{$T('financial-target')}}</span>
                    </v-card-title>

                    <v-card-text>
                        <span class="text-subtitle-2 font-weight-bold">{{$T('today-income')}}</span>
                        <v-progress-linear
                          color="primary"
                          class="mt-3 mb-1"
                          background-color="grey lighten-2"
                          rounded
                          height="10"
                          :value="(financialTarget.visitsToday / (financialTarget.value || 10)) * 100"
                        />
                        <span>
							{{
								$T('you-have-completed-$-out-of-$', {
									num1: $options.filters.formatNumber(financialTarget.visitsToday, 3) || 0,
									num2: financialTarget.value ? $options.filters.formatNumber(financialTarget.value, 3) : $options.filters.formatNumber(1000, 0)
								})
							}}
                        </span>
                    </v-card-text>
                </v-card>
            </template>

            <v-row>
                <!-- Last Rating -->
                <v-col cols="6">
                    <v-card outlined>
                        <v-card-title class="text-body-2">
                            <v-icon color="secondary" class="me-2">mdi-finance</v-icon>
                            <span>{{$T('last-rating')}}</span>
                        </v-card-title>

                        <v-card-text class="text-center">
                            <v-progress-circular
                              color="primary"
                              size="110"
                              width="8"
                              :value="review.averageMarks ? review.averageMarks.sum : 0"
                              rotate="-90"
                            >
                                <span class="text-h6 grey--text text--darken-2">
                                    {{$options.filters.formatNumber((review.averageMarks ? review.averageMarks.sum : 0), 3) + '%'}}
                                </span>
                            </v-progress-circular>
                            <p class="mt-2 mb-0">
                                {{$T('last-rating')}}: {{review?.reviews?.length > 0 ? review.reviews[0].marks.sum : 0}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>

                <!-- Leaves -->
                <v-col cols="6">
                    <v-card outlined>
                        <v-card-title class="text-body-2">
                            <v-icon color="secondary" class="me-2">mdi-airplane</v-icon>
                            <span>{{$T('leaves')}}</span>
                        </v-card-title>

                        <v-card-text class="text-center">
                            <v-progress-circular
                              color="primary"
                              size="110"
                              width="8"
                              :value="(leaves.remainingNumberOfLeaves / leaves.daysCount) * 100"
                              rotate="-90"
                            >
                                <span class="text-h6 grey--text text--darken-2">
								{{$options.filters.formatNumber(leaves.remainingNumberOfLeaves, 3)}}/{{$options.filters.formatNumber(leaves.daysCount, 3)}}
								</span>
                            </v-progress-circular>

                            <p class="mt-2 mb-0">
								{{$options.filters.formatNumber(leaves.remainingNumberOfLeaves, 3)}} {{$T('leaves-remaining')}}
							</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Loader from '../components/Loader'
import SalarySheet from '../components/SalarySheet'
import VicationSheet from '../components/VicationSheet'
import AdministrativeSheet from '../components/AdministrativeSheet'
import StockDetailsSheet from '../components/StockDetailsSheet'
import { mapState, mapGetters } from 'vuex'
import { usePrices, deletionExternal } from '@/configs/general.configs'
import moment from 'moment'
export default {
	name: 'Profile',

	data() {
		return {
			usePrices,

			loading: true,

			snackbar: false,
			message: null,

			fromDialog: false,
			toDialog: false,
			fromDate: moment().startOf('month').format('YYYY-MM-DD'),
			toDate: moment().endOf('month').format('YYYY-MM-DD'),
			workDaysStatsLoading: false,
		}
	},

	computed: {
		...mapState({
			userData: state => state.auth.userData,
			self: state => state.auth.self,
			balance: state => state.profile.balance,
			target: state => state.profile.target,
			financialTarget: state => state.profile.financialTarget,
			salary: state => state.profile.salary,
			leaves: state => state.profile.leaves,
			review: state => state.profile.review,
			vacations: state => state.vacations.vacations,
			workDaysStats: state => state.visits.workDaysStats,
			customersTypes: state => deletionExternal
				? state.entities.customersTypes.filter(c => c.name !== 'Externals')
				: state.entities.customersTypes,
			customersCountsByType: state => state.entities.customersCountsByType,
			salesSystem: state => state.configurations.systemConfigValue.properties?.find(c => c.key === 'salesSystem')?.value,
		}),
		...mapGetters({
			repType: 'auth/repType',
		}),
		shouldShowFinancialTarget() {
			return this.salesSystem && (this.repType === 'Financial' || this.repType === 'Both')
		},

		customersTotal() {
			return this.customersCountsByType.reduce((total, item) => total + (item.count || 0), 0)
		},

		customersByType() {
			if (!this.customersCountsByType.length) {
				return [];
			}

			return this.customersTypes.map(type => {
				const count = this.customersCountsByType.find(c => c.typeId === type.id)?.count || 0;
				return {
					id: type.id,
					name: type.name,
					count,
					percentage: this.customersTotal ? Math.round((count / this.customersTotal) * 100) : 0
				}
			})
		}
	},

	methods: {
		fetchWorkDaysStats() {
			this.workDaysStatsLoading = true
			return this.$store.dispatch('visits/fetchWorkDaysStats', {
				employeeId: this.self.employeeId,
				fromDate: this.fromDate,
				toDate: this.toDate,
			}).finally(() => {
				this.workDaysStatsLoading = false
			})
		}
	},

	components: {
		Loader,
		SalarySheet,
		VicationSheet,
		AdministrativeSheet,
		StockDetailsSheet
	},

	mounted() {
		Promise.all([
			usePrices && !this.balance
				? this.$store.dispatch('profile/fetchBalance')
				: null,
			this.$store.dispatch('profile/target'),
			this.shouldShowFinancialTarget ? this.$store.dispatch('profile/financialTarget') : null,
			this.$store.dispatch('profile/salary'),
			this.$store.dispatch('profile/leaves', { employeeId: this.self.employeeId }),
			this.$store.dispatch('profile/review'),
			this.fetchWorkDaysStats(),
			!this.customersTypes.length ? this.$store.dispatch('entities/fetchEntityType') : null,
			// catch: البطاقة تختفي فقط إذا لم يتوفر الـ endpoint، دون تعطيل باقي إحصائيات الصفحة
			this.$store.dispatch('entities/fetchCountsByType').catch(() => {}),
			!this.vacations.length ? this.$store.dispatch('vacations/fetchAll') : null
		]).finally(() => {
			this.loading = false;
		})
	},

	beforeDestroy() {
		this.$store.dispatch('profile/reset');
		this.$store.dispatch('visits/resetWorkDaysStats');
		this.$store.dispatch('entities/resetCountsByType');
	}
}
</script>

<style lang="scss" scoped>
.profile__balance-value {
	cursor: pointer;
}

.work-days-stats__values {
	transition: opacity .2s ease;

	&--loading {
		opacity: .4;
	}
}
</style>
